import { nodeJsServerRequest } from './functions';
import Log from './log';

class ConfigIniUtil {
    /**
     * @var {Object}
     */
    configIniContent;

    static getInstance() {
        if (typeof ConfigIniUtil.instance !== 'undefined') {
            return ConfigIniUtil.instance;
        }

        ConfigIniUtil.instance = new ConfigIniUtil();

        return ConfigIniUtil.instance;
    }

    /**
     * Load the config ini data.
     * @param {boolean} forceRequest
     * @return Promise<>
     */
    loadData(forceRequest = false) {
        return new Promise((resolve) => {
            if (!forceRequest && typeof this.configIniContent !== 'undefined') {
                resolve();

                return;
            }

            nodeJsServerRequest('CONFIG_INI_LOAD')
                .then((data) => {
                    this.configIniContent = data;

                    resolve();
                })
                .catch((e) => {
                    Log.error('CONFIG INI UTIL', `Error loading config ini data from nodejs server: ${e}`);
                });
        });
    }

    /**
     * Get a configuration parameter.
     * @param {string} paramName
     * @param {any} defaultValue The default value to be returned when the parameter was not found.
     * @return {any}
     */
    getParam = (paramName, defaultValue = null) => this.configIniContent[paramName] ?? defaultValue;

    debug = () => console.log(this.configIniContent);

    // SHORTCUT METHODS
    /**
     * @return {string}
     */
    getSkin = () => this.configIniContent['ui.skin'];

    /**
     * @return {string}
     */
    getDefaultLanguage = () =>
        this.configIniContent[`ui.skinLanguage.default[${this.getSkin()}]`] ??
        this.configIniContent[`ui.language.default`];

    /**
     * @return {string[]}
     */
    getSupportedLanguages = () =>
        (
            this.configIniContent[`ui.skinLanguage.supported[${this.getSkin()}]`] ??
            this.configIniContent[`ui.language.supported`]
        ).split(',');
}

export default ConfigIniUtil.getInstance();
